export default __webpack_public_path__ + "media/vendor/paper-dashboard-2-pro-html-v2.0.1/assets/img/flags/LS-d0cccca24f46911955fa63476baca28d.png";